import { message } from 'antd';
import { config } from "util/config";
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';
import { getUieDataSource } from 'components/UIBuilder/SectionFunction/Common';
import CustomBadge from 'components/CustomBadge';

let setAutoComplete = false;

//Search Address从google map找自动完成地址的数据源
export function searchAddressChange({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  if (parameter.length >= config.component.AutoComplete.minimumQueryCharacters && setAutoComplete === false) {
    setAutoComplete = true;

    let options = {
      componentRestrictions: {
        country: [pageComponent.props.authUser.Company.DefaultCountry]
      }
    };

    var input = document.getElementById('ClientSearchAddress');
    var autocomplete = new window.google.maps.places.Autocomplete(input, options);

    autocomplete.addListener('place_changed', function () {
      var place = autocomplete.getPlace();
      if (place.place_id.length > 150) {
        message.warning('The address you selected does not exist. Please select another one.');
      } else {
        for (var i = 0; i < place.address_components.length; i++) {
          switch (pageComponent.props.authUser.Company.DefaultCountry.toLowerCase()) {
            case 'nz':
              if (place.address_components[i].types[0] == "street_number") {
                formComponent.formRef.current?.setFieldValue('StreetNumber', place.address_components[i].long_name);
              }
              if (place.address_components[i].types[0] == "route") {
                formComponent.formRef.current?.setFieldValue('StreetName', place.address_components[i].long_name);
              }
              if (place.address_components[i].types[0] == "sublocality_level_1") {
                formComponent.formRef.current?.setFieldValue('Suburb', place.address_components[i].long_name);
              }
              if (place.address_components[i].types[0] == "locality") {
                formComponent.formRef.current?.setFieldValue('CityTown', place.address_components[i].short_name);
              }
              if (place.address_components[i].types[0] == "postal_code") {
                formComponent.formRef.current?.setFieldValue('Postcode', place.address_components[i].long_name);
              }
              break;
            default:
              if (place.address_components[i].types[0] == "street_number") {
                formComponent.formRef.current?.setFieldValue('StreetNumber', place.address_components[i].long_name);
              }
              if (place.address_components[i].types[0] == "route") {
                formComponent.formRef.current?.setFieldValue('StreetName', place.address_components[i].long_name);
              }
              if (place.address_components[i].types[0] == "locality") {
                formComponent.formRef.current?.setFieldValue('Suburb', place.address_components[i].long_name);
              }
              if (place.address_components[i].types[0] == "administrative_area_level_1") {
                formComponent.formRef.current?.setFieldValue('State', place.address_components[i].short_name);
              }
              if (place.address_components[i].types[0] == "postal_code") {
                formComponent.formRef.current?.setFieldValue('Postcode', place.address_components[i].long_name);
              }
              break;
          }
        }
        formComponent.formRef.current?.setFieldValue('ClientSearchAddress', place.formatted_address);
      }
    })
  }
}

export function addClientPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  setAutoComplete = false;
}

export function editClientPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  setAutoComplete = false;
}

//选Same As Client Address时给Postal Address赋值
export function setSameAsClientAddress({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  if (parameter) {
    formComponent.formRef.current?.setFieldValue('PostalStreetNumber', formComponent.formRef.current?.getFieldValue('StreetNumber'));
    formComponent.formRef.current?.setFieldValue('PostalStreetName', formComponent.formRef.current?.getFieldValue('StreetName'));
    formComponent.formRef.current?.setFieldValue('PostalSuburb', formComponent.formRef.current?.getFieldValue('Suburb'));
    formComponent.formRef.current?.setFieldValue('PostalState', formComponent.formRef.current?.getFieldValue('State'));
    formComponent.formRef.current?.setFieldValue('PostalCityTown', formComponent.formRef.current?.getFieldValue('CityTown'));
    formComponent.formRef.current?.setFieldValue('PostalPostcode', formComponent.formRef.current?.getFieldValue('Postcode'));
  } else {
    formComponent.formRef.current?.setFieldValue('PostalStreetNumber', '');
    formComponent.formRef.current?.setFieldValue('PostalStreetName', '');
    formComponent.formRef.current?.setFieldValue('PostalSuburb', '');
    formComponent.formRef.current?.setFieldValue('PostalState', '');
    formComponent.formRef.current?.setFieldValue('PostalCityTown', '');
    formComponent.formRef.current?.setFieldValue('PostalPostcode', '');
  }
}

//跳转管理ClientUser的页面
export function manageClientUser({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  pageComponent.props.history.push('/admin/client-user?clientId=' + parameter.ClientId + '&clientShowType=' + sectionComponent.state.searchParameter.ClientShowType + '&userState=' + sectionComponent.state.searchParameter.UserState);
}

//显示label选择的弹出框
export function showLabelDiv({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ manageLabelShow: true, currentClient: parameter });
  setTimeout(() => {
    pageComponent.labelDiv.current?.getLabelList();
  }, config.setTimeoutMilliSecond);
}

//显示 Client Category Label 选择的弹出框
export function showClientCategoryLabelDiv({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ manageClientCategoryLabelShow: true, currentClient: parameter });
  setTimeout(() => {
    pageComponent.clientCategoryLabelDiv.current?.getClientCategoryLabelList();
  }, config.setTimeoutMilliSecond);
}

//显示 Filter by Client Category Label 的弹出框（每次打开清空之前的选择）
export function showFilterByClientCategoryLabelDiv({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  httpClient
    .get('/Admin/ClientCategoryLabel/GetList')
    .then(({ data }) => {
      if (data.result) {
        let labelGroup = [];
        let labels = [];
        data.data.map((label, i) => {
          labels.push({
            label: <CustomBadge text={label.Name} backgroundColor={label.BackgroundColor} verticalAlign="top" />,
            value: label.ClientCategoryLabelId
          })
        })
        labelGroup.push({ Name: 'Client Category Label', DataList: labels });
        pageComponent.setState({ clientCategoryLabelGroup: labelGroup, filterByClientCategoryLabelShow: true });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

//显示JobColor选择的弹出框
export function showJobColorDiv({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ manageJobColorOptionShow: true, currentClient: parameter });
  setTimeout(() => {
    pageComponent.jobColorOptionDiv.current?.getJobColorOptionList();
  }, config.setTimeoutMilliSecond);
}


//显示Document列表的弹出框
export function showDocumentDiv({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ manageDocumentShow: true, currentClient: parameter });
  setTimeout(() => {
    pageComponent.documentDiv.current?.getDocumentList();
  }, config.setTimeoutMilliSecond);
}


//Client列表下载Excel
export function exportToExcel({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  globalFunction.download({ method: 'post', url: '/Admin/Client/GenerateExcel', filename: 'Client.xlsx', save: true });
}

export function filterClientNameCompany({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  const value = (parameter || '').trim();
  const baseData = pageComponent.state.sectionData?.Client || [];

  if (value.length < 2) {
    sectionComponent.child.current?.setState({ data: baseData });
    return;
  }

  const keyword = value.toLowerCase();
  const matchClient = (client) =>
    (client.Name && String(client.Name).toLowerCase().indexOf(keyword) >= 0) ||
    (client.Company && String(client.Company).toLowerCase().indexOf(keyword) >= 0);

  const isGrouped = baseData.length > 0 && baseData[0] && baseData[0].DataList !== undefined;
  const filtered = isGrouped
    ? baseData.map(group => ({ ...group, DataList: (group.DataList || []).filter(matchClient) }))
    : baseData.filter(matchClient);

  sectionComponent.child.current?.setState({ data: filtered });
}

export function getSectionDataByDefault({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;

  let searchParameter = { ...sectionComponent.state.searchParameter };
  searchParameter[uie.source] = parameter;
  if (uie.source === 'ClientShowType') {
    searchParameter['ClientShowType'] = parameter;
  }
  if (uie.source === 'UserState') {
    searchParameter['UserState'] = parameter;
  }

  sectionComponent.setState({ searchParameter, componentDefaultValue });

  let defaultFormData = { ...pageComponent.state.defaultFormData };
  defaultFormData[uie.source] = parameter;
  if (uie.source === 'ClientShowType') {
    defaultFormData['ClientShowType'] = parameter;
  }
  if (uie.source === 'UserState') {
    defaultFormData['UserState'] = parameter;
  }
  pageComponent.setState({ defaultFormData });
  let filterLoaded = true;
  sectionComponent.state.section.componentList.filter(c => c.type === 'View')[0].topFilterList[0].uieList.map((uie, i) => {
    if (uie.component === 'Input') return;
    if (componentDefaultValue[uie.source] === undefined || componentDefaultValue[uie.source] === null) {
      filterLoaded = false;
    }
  })

  if (filterLoaded) {
     if (pageComponent.state.clientShowType !== null) {
      defaultFormData['ClientShowType'] = pageComponent.state.clientShowType;
      searchParameter['ClientShowType'] = pageComponent.state.clientShowType;
      componentDefaultValue['ClientShowType'] = pageComponent.state.clientShowType;
      sectionComponent.setState({ searchParameter, componentDefaultValue });
      pageComponent.setState({ defaultFormData, clientShowType: null });
    }
    if (pageComponent.state.userState !== null) {
      defaultFormData['UserState'] = parseInt(pageComponent.state.userState);
      searchParameter['UserState'] = parseInt(pageComponent.state.userState);
      componentDefaultValue['UserState'] = parseInt(pageComponent.state.userState);
      sectionComponent.setState({ searchParameter, componentDefaultValue });
      pageComponent.setState({ defaultFormData, userState: null });
    }
    setTimeout(() => {
      sectionComponent.getSectionDataByDefault();
    }, config.setTimeoutMilliSecond);
  }
}

